// Touch effect
export default class TouchImgFx1 {
    constructor(el) {
        this.DOM = {el: el};
        // this.DOM.el.classList.add('touch');
        this.initEvents();
    }
    initEvents() {
        this.touchstartFn = (ev) => {
            ev.preventDefault();
            this.showImage();
            this.DOM.el.classList.add('touched');
        };
        // this.touchmoveFn = (ev) => {
        //     this.hideImage();
        // };
        this.touchendFn = (ev) => {
            this.hideImage();
            const viewIcon = this.DOM.el;
            // this.DOM.el.classList.remove('touched');
            setTimeout(function(){
                viewIcon.classList.remove('touched');
            },720);
        };
        
        this.DOM.el.addEventListener('touchstart', this.touchstartFn);
        // this.DOM.el.addEventListener('touchmove', this.touchmoveFn);
        this.DOM.el.addEventListener('touchend', this.touchendFn);
    }
    showImage() {
        const touchRevealImg = document.querySelector('.touch-reveal__img');
        const touchReveal = document.querySelector('.touch-reveal');
        touchRevealImg.style.backgroundImage = `url(${this.DOM.el.dataset.img})`;
        //touchRevealImg.classList.add(${this.DOM.el.dataset.orientation});
        const orientation = `${this.DOM.el.dataset.orientation}`;
        touchReveal.classList.add(orientation);
    }
    hideImage() {
        const touchRevealImg = document.querySelector('.touch-reveal__img');
        const touchReveal = document.querySelector('.touch-reveal');
        const orientation = `${this.DOM.el.dataset.orientation}`;
        setTimeout(function(){
            touchRevealImg.style.backgroundImage = `none`;
            touchReveal.classList.remove(orientation);
        },600);
        
    }
}